export default __webpack_public_path__ + "static/media/tattooArt.ac9b058b.jpg";